import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsInStock, setIsInStock } from '../filterSlice'
import Switch from '../base/Switch'

const Availability = () => {
    const isInStock = useSelector(selectIsInStock)

    return <Switch name={'Только в наличии'} action={setIsInStock} defaultChecked={isInStock} />
}

export default Availability
